// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--xiq3M";
export var videoSideBySide = "styles-module--video-side-by-side--fQSWC";
export var video = "styles-module--video--WAK-V";
export var text = "styles-module--text--V9ADi";
export var title = "styles-module--title--GSGvL";
export var description = "styles-module--description--F4K0n";
export var list = "styles-module--list--8mS08";
export var listItem = "styles-module--list-item--oKrlA";
export var checkIcon = "styles-module--check-icon--wNwwg";